import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import Hero from '../components/sections/Hero';
import Services from '../components/sections/Services';
import Showcase from '../components/sections/Showcase';
import Portfolio from '../components/sections/Portfolio';
import FAQ from '../components/sections/FAQ';
import Contact from '../components/sections/Contact';
import { getSettings } from '../services/firestoreService';
import { GlobalSettings } from '../types';

const Home: React.FC = () => {
  const [settings, setSettings] = useState<GlobalSettings | null>(null);
  const location = useLocation();

  useEffect(() => {
    getSettings().then((s) => setSettings(s as GlobalSettings));
  }, []);

  useEffect(() => {
    // Handle cross-page scrolling — offset clears the fixed header (see useSectionNavigation).
    if (location.state && (location.state as any).scrollTo) {
      const sectionId = (location.state as any).scrollTo;
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          window.scrollTo({
            top: element.offsetTop - 96,
            behavior: 'smooth'
          });
        }
      }, 100);
      // Clear state so it doesn't re-scroll on refresh
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  return (
    <div className="sw-app">
      {/* Scroll Progress Indicator */}
      <div id="scroll-progress" aria-hidden="true"></div>
      
      <Header />
      
      <main id="main-content" role="main" tabIndex={-1}>
        <Hero settings={settings} />
        <Services />
        <Showcase />
        <Portfolio />
        <FAQ />
        <Contact />
      </main>
      
      <Footer />
    </div>
  );
};

export default Home;
